/** @typedef {Object} ALKForgotPassword
 * @property {String} email
 */

(function () {
  "use strict";

  angular
    .module("alk.authentication")
    .factory("ALKForgotPassword", ALKForgotPassword);

  /** @name ALKForgotPassword
   * @ngdoc factory
   * @description A factory for an object that encapsulates forgot password requests.
   * @param {String} email - email of the user to which a "forgot password" email will be sent
   * @example
   * var forgot = new ALKForgotPassword(email);
   * @returns ALKForgotPassword
   * @memberof alk.authentication
   */
  function ALKForgotPassword() {
    return function (email) {
      this.email = email;
    };
  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-authentication/factories/forgotPassword.factory.js